// extracted by mini-css-extract-plugin
export default {"root":"GroupList_root__6s93Y"};